export const useRedirectWhatsApp = () => {
  const redirect = (phone: string, message: string) => {
    window.open(`https://api.whatsapp.com/send?phone=55${phone}&text=${encodeURI(message)}`, '_blank')
  }

  return {
    redirect
  }
}
